import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { ClientCreationForm } from '../components/ClientCreationForm';
import { ClientCreationResponse } from '@digitaltattoo/types';

export function QuickClientCreatePage() {
  const { t } = useTranslation();

  const handleSuccess = (response: ClientCreationResponse) => {
    console.log('Client creation successful:', response);
    // The form handles the success display internally
  };

  const handleCancel = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-accent-50 pt-24 pb-12 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <button
            onClick={handleCancel}
            className="inline-flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors border border-gray-300 shadow-sm mb-4"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>{t('quickClientCreate.backToHome')}</span>
          </button>
          
          <h1 className="text-3xl font-display font-bold text-textPrimary mb-4">
            {t('quickClientCreate.title')}
          </h1>
          <p className="text-textSecondary">
            {t('quickClientCreate.subtitle')}
          </p>
        </div>

        {/* Client Creation Form */}
        <ClientCreationForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          isBackoffice={false}
        />
      </div>
    </div>
  );
}